var _rect, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DZone4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 908,
    y: 171,
    width: 103.87,
    height: 23.51,
    rx: 11.755,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M930.75 188.255V187.232L937.023 177.869H930.682V176.619H938.704V177.641L932.432 187.005H938.773V188.255H930.75ZM950.888 182.437C950.888 183.664 950.666 184.725 950.223 185.619C949.78 186.513 949.172 187.202 948.399 187.687C947.626 188.172 946.744 188.414 945.751 188.414C944.759 188.414 943.876 188.172 943.103 187.687C942.331 187.202 941.723 186.513 941.28 185.619C940.836 184.725 940.615 183.664 940.615 182.437C940.615 181.21 940.836 180.149 941.28 179.255C941.723 178.361 942.331 177.672 943.103 177.187C943.876 176.702 944.759 176.46 945.751 176.46C946.744 176.46 947.626 176.702 948.399 177.187C949.172 177.672 949.78 178.361 950.223 179.255C950.666 180.149 950.888 181.21 950.888 182.437ZM949.524 182.437C949.524 181.429 949.355 180.579 949.018 179.886C948.685 179.192 948.232 178.668 947.66 178.312C947.092 177.956 946.456 177.778 945.751 177.778C945.047 177.778 944.408 177.956 943.836 178.312C943.268 178.668 942.816 179.192 942.478 179.886C942.145 180.579 941.978 181.429 941.978 182.437C941.978 183.444 942.145 184.295 942.478 184.988C942.816 185.681 943.268 186.206 943.836 186.562C944.408 186.918 945.047 187.096 945.751 187.096C946.456 187.096 947.092 186.918 947.66 186.562C948.232 186.206 948.685 185.681 949.018 184.988C949.355 184.295 949.524 183.444 949.524 182.437ZM962.964 176.619V188.255H961.601L955.26 179.119H955.146V188.255H953.737V176.619H955.101L961.464 185.778H961.578V176.619H962.964ZM966.264 188.255V176.619H973.287V177.869H967.673V181.8H972.923V183.05H967.673V187.005H973.377V188.255H966.264ZM980.809 185.869V184.71L985.923 176.619H986.764V178.414H986.195L982.332 184.528V184.619H989.218V185.869H980.809ZM986.286 188.255V185.516V184.977V176.619H987.627V188.255H986.286Z",
    fill: "#2E3838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 959.935,
    cy: 261.51,
    r: 25.3,
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 959.935,
    cy: 261.51,
    r: 38,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 959.935,
    cy: 261.51,
    r: 13.65,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DZone4);
export default __webpack_public_path__ + "static/media/3d_zone_4.b64f9a5dc4e9565d8761c64b5e86a795.svg";
export { ForwardRef as ReactComponent };